import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { International } from '../International'
import { Grid } from '../Grid'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  properties = properties || {
    module: 'grid', // grid / international
  }
  const module = properties?.module
  return (
    <AppContainer className={globalClasses.join(' ')}>
      {module === 'international' && (
        <TextWidth>
          <International
            titleDE='Schweizer Städte im internationalen Vergleich'
            titleFR='Villes suisses en comparaison internationale'
            tenant={tenant}
          />
        </TextWidth>
      )}

      {module !== 'international' && (
        <TextWidth>
          <Grid
            titleDE='Die dichtesten Quadratkilometer in Schweizer Städten'
            titleFR='Voici les kilomètres carrés les plus denses dans différentes villes suisses'
            tenant={tenant}
          />
        </TextWidth>
      )}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
